import { VStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { useStoreSettings } from '../context/store-settings.context';
import { AddressBlock } from './address-block';
import { ContactBlock } from './contact-block';
import { DaypartsBlock } from './dayparts-block';
import Section from './section';
import { SiteConfigBlock } from './site-config-block';
import { SiteInfoBlock } from './site-info-block';

export const GeneralInfoView = () => {
  const { t } = useTranslation();
  const site = useStoreSettings(_ => _.site);
  const onSupportPress = useStoreSettings(_ => _.onSupportPress);

  const storeHours = site.config?.storeHoursConfig;

  return (
    <Section title={t('store_settings:general_info')} lastModified={site.lastModifiedOnUtc} _supportLink={{ onPress: onSupportPress }}>
      <VStack space={3} p={4}>
        <SiteInfoBlock site={site} />

        <AddressBlock address={site.address} />

        <ContactBlock contact={site.primaryContact} />

        <SiteConfigBlock site={site} />

        <DaypartsBlock dayparts={storeHours?.dayparts} dayblocks={storeHours?.dopBlocks} />
      </VStack>
    </Section>
  );
};
